require('intersection-observer');
var objectFitImages = require('object-fit-images');
var throttle = require('throttle-debounce').throttle;

global.jQuery = require('jquery');
var $ = global.jQuery;
require('jquery-scrollevents');


// init object-fit polyfill
$(document).ready(function() {
    objectFitImages();
});


// bind nav toggle behaviour //////////////////////////////////////////////
var $navOpenLinkEl = $('.js-navOpenLink');
var $navWrapperEl = $('.js-navWrapper');
if ($navOpenLinkEl.length) {
    $navOpenLinkEl.on('click', function(e) {
        e && e.preventDefault();
        $navWrapperEl.toggleClass('is-open');
    });
}


// bind subnav show/hide behaviour ////////////////////////////////////////
var subnavTimer;
var subnavTimeout = 250;
var subnavFadeSpeed = 'fast';
var subnavBreakpoint = 1200;
$(document).on('mouseenter', '.js-navListItem', function(e) {
    if (document.documentElement.clientWidth < subnavBreakpoint) return;
    var $subnavEl = $(e.currentTarget).find('.js-subnav');
    if ($subnavEl.length) {
        $subnavEl.stop().fadeIn(subnavFadeSpeed);
        window.clearTimeout(subnavTimer);
    }
});
$(document).on('mouseleave', '.js-navListItem', function(e) {
    if (document.documentElement.clientWidth < subnavBreakpoint) return;
    var $subnavEl = $(e.currentTarget).find('.js-subnav');
    if ($subnavEl.length) {
        subnavTimer = window.setTimeout(function() {
            $subnavEl.stop().fadeOut(subnavFadeSpeed);
        }, subnavTimeout);
    }
});
$(document).on('mouseenter', '.js-subnav', function(e) {
    if (document.documentElement.clientWidth < subnavBreakpoint) return;
    window.clearTimeout(subnavTimer);
});
$(document).on('mouseleave', '.js-subnav', function(e) {
    if (document.documentElement.clientWidth < subnavBreakpoint) return;
    var $subnavEl = $(e.currentTarget);
    subnavTimer = window.setTimeout(function() {
        $subnavEl.stop().fadeOut(subnavFadeSpeed);
    }, subnavTimeout);
});


// subnav link hover behaviour ////////////////////////////////////////////
var $subnavArtistLinkEls = $('.js-subnavArtistLink');
var $subnavFeaturedImageEl = $('.js-subnavFeaturedImage');
var $subnavFeaturedImageLinkEl = $('.js-subnavFeaturedImageLink');
$(document).on('mouseenter', '.js-subnavArtistLink', function(e) {
    var $linkEl = $(e.target);
    $subnavFeaturedImageEl.attr('src', $linkEl.attr('data-img-src'));
    $subnavFeaturedImageEl.attr('alt', $linkEl.text());
    $subnavFeaturedImageLinkEl.attr('href', $linkEl.attr('href'));
});


// bind form field label display behaviour ////////////////////////////////
var $fieldEls = $('.js-field');
$fieldEls.each(function(i, elem) {
    var $fieldEl = $(elem);
    var $inputEl = $fieldEl.find('input, textarea');
    var $labelEl = $fieldEl.find('label');
    $inputEl.on('focus', function(e) {
        $labelEl.addClass('is-hidden');
    });
    $inputEl.on('blur', function(e) {
        if ($inputEl.val() === '') {
            $labelEl.removeClass('is-hidden');
        }
    });

    // correctly set up initial state
    $labelEl.addClass('is-hidden');
    $inputEl.trigger('blur');
});


// bind newsletter modal show behaviour ///////////////////////////////////
var $newsletterModalEl = $('.js-newsletterModalWrapper');
if ($newsletterModalEl.length) {
    $(document).on('click', '.js-newsletterOpenLink', function(e) {
        e && e.preventDefault();
        if (!$newsletterModalEl.is(':visible')) {
            $newsletterModalEl.fadeIn();
        }
    });
    $(document).on('click', '.js-newsletterCloseLink', function(e) {
        e && e.preventDefault();
        if ($newsletterModalEl.is(':visible')) {
            $newsletterModalEl.fadeOut();
        }
    });
    $newsletterModalEl.on('click', function(e) {
        if ($(e.target).is($newsletterModalEl)) {
            $('.js-newsletterCloseLink').first().trigger('click');
        }
    });
}


// bind search modal show behaviour ///////////////////////////////////////
var $searchModalEl = $('.js-searchModalWrapper');
if ($newsletterModalEl.length) {
    $(document).on('click', '.js-searchOpenLink', function(e) {
        e && e.preventDefault();
        if (!$searchModalEl.is(':visible')) {
            $searchModalEl.fadeIn();
        }
    });
    $(document).on('click', '.js-searchCloseLink', function(e) {
        e && e.preventDefault();
        if ($searchModalEl.is(':visible')) {
            $searchModalEl.fadeOut();
        }
    });
    $searchModalEl.on('click', function(e) {
        if ($(e.target).is($searchModalEl)) {
            $('.js-searchCloseLink').first().trigger('click');
        }
    });
}


// bind promo toast show behaviour ////////////////////////////////////////
var $promoToastEl = $('.js-promoToast');
if ($promoToastEl.length) {
    $(document).ready(function() {
        window.setTimeout(function() {
            $promoToastEl.addClass('is-visible');
        }, 2000);
    });
    $promoToastEl.find('a').on('click', function(e) {
        e && e.preventDefault();
        $promoToastEl.removeClass('is-visible');
    });
}


// bind 'back to top' link ////////////////////////////////////////////////
$(document).on('click', '.js-backToTopLink', function(e) {
    e && e.preventDefault();
    $('html, body').animate({ scrollTop: 0 });
});


// bind 'scroll to products' link /////////////////////////////////////////
$(document).on('click', '.js-skipToProductsLink', function(e) {
    e && e.preventDefault();
    var $artistProductsEl = $('.js-artistProducts');
    $('html, body').animate({
        scrollTop: $artistProductsEl.offset().top - 50
    });
});


// login/password form switch behaviour ///////////////////////////////////
var $loginFormWrapperEl = $('.js-loginFormWrapper');
var $passwordFormWrapperEl = $('.js-forgotPasswordFormWrapper');
var $forgotPasswordLinkEl = $('.js-forgotPasswordLink');
var $passwordBackLinkEl = $('.js-passwordBackLink');
if ($loginFormWrapperEl.length) {
    $forgotPasswordLinkEl.on('click', function(e) {
        e && e.preventDefault();
        $loginFormWrapperEl.hide();
        $passwordFormWrapperEl.show();
    });
    $passwordBackLinkEl.on('click', function(e) {
        e && e.preventDefault();
        $passwordFormWrapperEl.hide();
        $loginFormWrapperEl.show();
    });

    // activate by default if #recover hash is present
    if (window.location.hash === '#recover') {
        $forgotPasswordLinkEl.trigger('click');
    }
}


// form address add/edit switch behaviour /////////////////////////////////
var $addressListWrapperEl = $('.js-addressListWrapper');
var $newAddressFormWrapperEl = $('.js-newAddressFormWrapper');
var $editAddressFormWrapperEls = $('.js-editAddressFormWrapper');
var $newAddressLinkEl = $('.js-newAddressLink');
var $editAddressLinkEls = $('.js-editAddressLink');
var $deleteAddressLinkEls = $('.js-deleteAddressLink');
var $cancelAddEditAddressLinkEls = $('.js-cancelAddEditAddressLink');
$newAddressLinkEl.on('click', function(e) {
    e && e.preventDefault();
    $addressListWrapperEl.hide();
    $newAddressFormWrapperEl.show();
});
$editAddressLinkEls.on('click', function(e) {
    e && e.preventDefault();
    $addressListWrapperEl.hide();
    $editAddressFormWrapperEls.filter('[data-id="' + $(this).attr('data-id') + '"]').show();
});
$deleteAddressLinkEls.on('click', function(e) {
    e && e.preventDefault();
    Shopify.CustomerAddress.destroy($(this).attr('data-id'));
});
$cancelAddEditAddressLinkEls.on('click', function(e) {
    e && e.preventDefault();
    $editAddressFormWrapperEls.hide();
    $newAddressFormWrapperEl.hide();
    $addressListWrapperEl.show();
});


// bind product page pseudo-sticky positioning ////////////////////////////
// native sticky positioning with an oversize element proved tricky ///////
var $productDetailEl = $('.js-stickyProductDetails');
var scrollThrottleInterval = 10;
var productBreakpoint = 1000;
if ($productDetailEl.length) {
    var viewportHeight;
    var elementHeight;
    var elementWidth;
    var elementTop;
    var elementBottom;
    var elementStickyLimit;
    var scrollBottom;

    $(window).on('load resize', function(e) {
        $productDetailEl.removeAttr('style');
        viewportHeight = document.documentElement.clientHeight;
        elementHeight = $productDetailEl.height();
        elementWidth = $productDetailEl.width();
        elementTop = $productDetailEl.offset().top;
        elementBottom = $productDetailEl.offset().top + elementHeight;
        elementStickyLimit = $productDetailEl.parent().offset().top +
                             $productDetailEl.parent().height();
        $(window).trigger('scroll');
    });

    $(window).on('scroll', throttle(scrollThrottleInterval, function(e) {
        if (document.documentElement.clientWidth < productBreakpoint) return;
        scrollBottom = $(window).scrollTop() + viewportHeight;

        if (elementHeight < viewportHeight && scrollBottom < (elementStickyLimit - 2 * parseInt($productDetailEl.parent().css('padding-bottom'), 10) + (viewportHeight - elementHeight))) {
            // short detail element, stick to top
            $productDetailEl.css({
                position: 'fixed',
                top: elementTop + 'px',
                bottom: 'auto',
                maxWidth: elementWidth + 'px'
            });
        }
        else {
            // regular bottom-anchored sticky behaviour
            if (scrollBottom >= elementBottom) {
                var bottom = 0;
                if (scrollBottom >= elementStickyLimit) {
                    bottom = scrollBottom - elementStickyLimit;
                }
                $productDetailEl.css({
                    position: 'fixed',
                    top: 'auto',
                    bottom: bottom + 'px',
                    maxWidth: elementWidth + 'px'
                });
            }
            else {
                $productDetailEl.removeAttr('style');
            }
        }
    }));
}

// social sharing popups //////////////////////////////////////////////////
$(document).on('click', '.js-sharinglink', function(e) {
    var href = $(e.target).attr('href');
    if (href.indexOf('mailto:') === -1) {
        e && e.preventDefault();
        window.open(href,
                    '_blank',
                    'width=720,height=570,status=no,location=no');
    }
});

// variant select /////////////////////////////////////////////////////////
var $variantSelectEl = $('.js-variantSelect');
if ($variantSelectEl.length) {
    $variantSelectEl.on('change', function(e) {
        var selectedOption = $variantSelectEl.find(':selected');
        window.location.search = '?variant=' + selectedOption.attr('value');
    });
}

// grid item overlay height fixes for variable-length titles //////////////
var $gridEls = $('.ContentGrid--shop, .ContentGrid--shopSecondary, .ContentGrid--home, .ContentGrid--magazine, .ContentGrid--secondary');
var $itemOverlayTextEls = $gridEls.find('.ContentGrid-item-overlay.is-outboard');
$(window).on('load resize', function(e) {
    var maxHeight = 0;
    $itemOverlayTextEls.css('min-height', 0);
    $itemOverlayTextEls.each(function(i, elem) {
        var $item = $(elem);
        var height = $item.height();
        if (height > maxHeight) maxHeight = height;
    });
    $itemOverlayTextEls.css('min-height', maxHeight + 'px');
});
var $relatableEls = $('[data-relatable]');
if ($relatableEls.length) {
    var timer = window.setInterval(function() {
        // check for rendered flag on Relatable
        if ($relatableEls.last().hasClass('rendered')) {
            window.clearInterval(timer);
            $itemOverlayTextEls = $('.ContentGrid-item-overlay.is-outboard');
            $(window).trigger('resize');

            // swap image sources /////////////////////////////////////////
            var $relatableInnerImageEls = $relatableEls.find('.ContentGrid-item-image');
            $relatableInnerImageEls.each(function(i, elem) {
                var $imgEl = $(elem);
                var src = $imgEl.attr('src');
                var newSrc = src.replace('_grande.', '_320x205_crop_center.');
                $imgEl.attr('src', newSrc);
            });
        }
    }, 100);
    // emergency bail-out, we don't want that timer sticking around
    window.setTimeout(function() {
        window.clearInterval(timer);
    }, 5000);
}

// pull-quote scroll (from Thomas) ////////////////////////////////////////
var $items = $('.pull-quote-content');
if ($items.length) {
    $items.each(function() {
        var $this = $(this);
        var $next = $this.nextAll('.pull-quote-content, .shop').first();
        var $parent = $this.parent();
        var $inner = $this.find('.pull-quote-content__right');
        var start = function() {
            return $this.position().top - $(window).height();
        };
        var end = function() {
            if ($next.length) {
                return $next.position().top;
            }
            else {
                return $parent.position().top + $parent.height();
            }
        };

        $(window).scrollBetween({ start: start, end: end }, function(event) {
            var diff = end() - start() - $(window).height() - $inner.height();
            $inner.css({
                transform: 'translateY(' + (diff * event.progress) + 'px)'
            });
        });
    });
}
